var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragAndDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58072 4.49512C6.08563 4.49512 6.49494 4.08581 6.49494 3.5809C6.49494 3.076 6.08563 2.66669 5.58072 2.66669C5.07581 2.66669 4.6665 3.076 4.6665 3.5809C4.6665 4.08581 5.07581 4.49512 5.58072 4.49512Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0221 4.49512C10.527 4.49512 10.9363 4.08581 10.9363 3.5809C10.9363 3.076 10.527 2.66669 10.0221 2.66669C9.51722 2.66669 9.10791 3.076 9.10791 3.5809C9.10791 4.08581 9.51722 4.49512 10.0221 4.49512Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58072 8.91425C6.08563 8.91425 6.49494 8.50494 6.49494 8.00003C6.49494 7.49512 6.08563 7.08582 5.58072 7.08582C5.07581 7.08582 4.6665 7.49512 4.6665 8.00003C4.6665 8.50494 5.07581 8.91425 5.58072 8.91425Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0221 8.91425C10.527 8.91425 10.9363 8.50494 10.9363 8.00003C10.9363 7.49512 10.527 7.08582 10.0221 7.08582C9.51722 7.08582 9.10791 7.49512 9.10791 8.00003C9.10791 8.50494 9.51722 8.91425 10.0221 8.91425Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58072 13.3334C6.08563 13.3334 6.49494 12.9241 6.49494 12.4192C6.49494 11.9143 6.08563 11.5049 5.58072 11.5049C5.07581 11.5049 4.6665 11.9143 4.6665 12.4192C4.6665 12.9241 5.07581 13.3334 5.58072 13.3334Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0221 13.3334C10.527 13.3334 10.9363 12.9241 10.9363 12.4192C10.9363 11.9143 10.527 11.5049 10.0221 11.5049C9.51722 11.5049 9.10791 11.9143 9.10791 12.4192C9.10791 12.9241 9.51722 13.3334 10.0221 13.3334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDrop);
export default __webpack_public_path__ + "static/media/DragAndDrop.5b75eeaee7d4f2ae4d80ffde332171e8.svg";
export { ForwardRef as ReactComponent };